import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClickAwayHandler',
  emits: ["clicked-away"],
  setup(__props, { emit }) {

const content = ref<HTMLElement | null>(null);

onMounted(() => {
	window.addEventListener("click", clickAwayHandler);
});

onUnmounted(() => {
	window.removeEventListener("click", clickAwayHandler);
});



function clickAwayHandler(event: MouseEvent) {
	// TODO: Make it so the event is only emitted when the mouse event is click down outside of the element
	const contentElement = content.value as HTMLElement;
	if (!contentElement.contains(event.target as HTMLElement))
		emit("clicked-away");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "content",
    ref: content
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})